module.exports = __webpack_public_path__ + "img/jo.fbeac94f.svg";